export default {
  headerBrand : '40px',
  xxlg        : '30px',
  xlg         : '24px',
  lg          : '18px',
  default     : '14px',
  sm          : '12px',
};
